import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { InventoryResourceRequirement } from "../generic/inventory-resource-requirement/InventoryResourceRequirement";
export var MissingResources = function (_a) {
    var missingResources = _a.missingResources;
    var missingResourceElements = missingResources.map(function (missingResource, index) {
        var available = missingResource.available, missing = missingResource.missing;
        var required = Long.fromValue(available).add(missing);
        return (React.createElement("div", { className: "not-enough-dialog-content__requirement-item", key: index },
            React.createElement(InventoryResourceRequirement, { required: required, resourceId: missingResource.resource.id, iconStyleId: IdStyles.IconExtraLarge })));
    });
    return (React.createElement("div", { className: "flex flex--guts " + IdStyles.IconAmount }, missingResourceElements));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/MissingResources.tsx
// module id = 2853
// module chunks = 3